import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ path, width, height, color, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      style={{ ...style, fill: color }}
    >
      {path}
    </svg>
  )
}

Icon.propTypes = {
  /** A path or other svg element */
  path: PropTypes.node.isRequired,
  /** Width of the icon */
  width: PropTypes.number,
  /** Height of the icon */
  height: PropTypes.number,
  /** Additional styles for the svg element */
  style: PropTypes.object,
  /** Color of the icon. Shortcut for `style={{ fill: 'somecolor' }}` */
  color: PropTypes.string
}

Icon.defaultProps = {
  width: 24,
  height: 24,
  style: {}
}

export default Icon

// Icon path definitions

export const ICON_LOCATION = (
  <path
    d="M3.3 8.6c0 1.7.6 3.3 1.4 4.6L11.9 24s5.4-8 7.1-10.8c.8-1.3 1.4-2.9 1.4-4.6 0-4.7-3.8-8.6-8.6-8.6-4.6 0-8.5 3.9-8.5 8.6zm5.2 0c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4z"
    fill="#4a83fb"
  />
)

export const ICON_CROSS = (
  <g>
    <circle cx="12" cy="12" r="12" fill="#99999a" />
    <path
      d="M13.4 12l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L12 10.6 9.2 7.8c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2.8 2.8-2.8 2.8c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.8-2.8 2.8 2.8c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L13.4 12z"
      fill="#fff"
    />
  </g>
)

export const ICON_X = (
  <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
)

export const ICON_X_LIGHT = (
  <g>
    <path d="M0.057,1.414L1.471,0L14.05,12.579l-1.414,1.414L0.057,1.414z"/>
    <path d="M12.696-0.071l1.415,1.414L1.532,13.922l-1.414-1.414L12.696-0.071z"/>
  </g>
)

export const ICON_PLUS = <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />

export const ICON_SNOWFLAKE = (
  <g>
    <path
      d="M15.2 12.8l-1.5-.8 1.4-.8 1.4.8-1.3.8zm-.9 3.2l-1.4-.8v-1.6l1.4.8V16zm-1.4-7.1l1.4-.9v1.6l-1.4.8V8.9zm-1.8 1.6l-1.4-.8V8l1.4.8v1.7zm0 4.7l-1.4.8v-1.6l1.4-.8v1.6zm-2.3-2.4L7.4 12l1.4-.8 1.4.8-1.4.8zM22.4 7V6l-.8-.5h-.1l-2.3 1.3V4.1l-.8-.5h-.1l-.8.5v3.7l-1.5.9V6l-.8-.5h-.1l-2.3 1.3V5.2L16 3.4V2.3l-.8-.5h-.1l-2.3 1.3V.5L12 0l-.8.5v2.7L8.9 1.9h-.1l-.8.4v1.1l3.1 1.8v1.6L8.9 5.5h-.1L8 6v2.7l-1.5-.8V4.1l-.8-.4h-.1l-.8.5v2.7L2.5 5.5h-.1l-.8.5v1.1l2.3 1.3-2.3 1.3v1.1l.8.5h.1l3.1-1.8 1.4.8-2.3 1.3v1.1L7 14l-1.4.8L2.5 13h-.1l-.8.5v1.1l2.3 1.3L1.6 17v1.1l.8.5h.1l2.3-1.3V20l.8.5h.1l.8-.5v-3.7l1.4-.8V18H8l.8.5h.1l2.3-1.3v1.6L8 20.7v1.1l.8.5h.1l2.3-1.3v2.7l.8.3.8-.5v-2.7l2.3 1.3h.1l.8-.5v-1.1l-3.1-1.8v-1.6l2.3 1.3h.1l.7-.4v-2.7l1.4.8v3.7l.8.5h.1l.8-.5v-2.7l2.3 1.3h.1l.8-.5v-1.1L20 15.5l2.3-1.3v-1.1l-.8-.5h-.1l-3.1 1.8-1.4-.8 2.3-1.3v-1.1l-2.3-1.3 1.4-.8 3.1 1.8h.1l.8-.5V9.6L20 8.3 22.4 7z"
      fill="#83c7fd"
    />
    <path
      d="M15.2 12.8l-1.5-.8 1.4-.8 1.4.8-1.3.8zm-2.3-3.9l1.4-.9v1.6l-1.4.8V8.9zm9.5 8.2l-2.3-1.4 2.3-1.3v-1.1l-.8-.5h-.1l-3.1 1.8-1.4-.8 2.3-1.3v-1.1L17 10.1l1.4-.8 3.1 1.8h.1l.8-.5v-1l-2.3-1.3L22.4 7V6l-.8-.5h-.1l-2.3 1.3V4.1l-.8-.5h-.1l-.8.5v3.7l-1.5.9V6l-.8-.5h-.1l-2.3 1.3V5.2L16 3.4V2.3l-.8-.5h-.1l-2.3 1.3V.5L12 0h-.1v11.6s10.2 6.1 10.5 6.3V17.1zM11.1 15.2l-1.4.8v-1.6l1.4-.8v1.6zM1.6 18l.8.5h.1l2.3-1.3v2.7l.8.5h.1l.8-.5v-3.7l1.4-.8V18H8l.8.5h.1l2.3-1.3v1.6L8 20.7v1.1l.8.5h.1l2.3-1.3v2.7l.8.3-.1-12.3L1.6 18z"
      fill="#56afee"
    />
  </g>
)

export const ICON_RELOAD = (
  <g>
    <path
      d="M11.9 20.2c-4.5-.1-8.2-3.8-8.1-8.4s3.8-8.2 8.4-8.1c2 0 3.7.7 5.1 1.9l-3.7 3.1 10.3 2.2L23.6.4l-3.4 2.8c-2.1-2-4.9-3.2-8-3.2C5.6-.1.2 5.2.1 11.8-.1 18.4 5.2 23.9 11.8 24c5.2.1 9.7-3.1 11.4-7.7l-3.8-.6c-1.3 2.7-4.2 4.6-7.5 4.5z"
      fill="#737373"
    />
    <path
      d="M3.8 11.9c.1-4.5 3.8-8.2 8.4-8.1 1.9 0 3.7.7 5.1 1.9l2.9-2.4c-2.1-2-4.9-3.2-8-3.2C5.6-.1.2 5.2.1 11.8c0 2.5.7 4.7 1.9 6.7L4.9 16c-.7-1.2-1.1-2.6-1.1-4.1z"
      fill="#373737"
    />
    <path d="M13.6 8.7l10.3 2.2L23.6.4z" />
  </g>
)

export const ICON_DOTS = (
  <g>
    <circle cx="2.8" cy="12" r="2.8" fill="#737373" />
    <circle cx="12" cy="12" r="2.8" fill="#373737" />
    <circle cx="21.2" cy="12" r="2.8" fill="#09090a" />
  </g>
)

export const ICON_FLAME = (
  <g>
    <path
      d="M4.9 7.9c-.3.6-.6 1.3-.6 2-.1.8 0 1.3.3 2s1 1.1 1.8 1.1c.6 0 1.1-.3 1.4-.8.4-.6.4-1.3.2-2-.7-2.6.5-5.3 2.8-6.5.9-.5 1.4-1.4 1.4-2.4 0-.4-.1-.9-.3-1.3 1.2.5 2 1.8 2 3.2 0 .4-.1.9-.2 1.3v.1c-.2.5-.3 1.1-.3 1.6 0 1.1.3 2.1.9 2.8.7 1 2.1 1.2 3.1.5.4-.3.6-.5.7-.8v-.1c.5-1 .6-2.1.3-3.1 2 2.1 3.2 5.8 3.2 8.7 0 5.4-4.4 9.7-9.7 9.7s-9.7-4.4-9.7-9.7c.1-2.4.8-4.3 2.7-6.3z"
      fill="#e54a18"
    />
    <path
      d="M8.4 23.3c1.2.5 2.4.7 3.6.7 5.4 0 9.7-4.4 9.7-9.7 0-2.9-1.2-6.6-3.2-8.7.2 1.1.1 2.2-.3 3.1v.1c-.6 1.1-1.9 1.5-3 .9-.3-.2-.5-.4-.7-.6-.6-.8-.9-1.7-.9-2.8 0-.6.1-1.1.3-1.6v-.1c.1-.5.1-1 .1-1.4 0-1.4-.8-2.6-2-3.2.6.8.8 1.8.8 2.8 0 1.3-.4 2.5-1.2 3.4-.5.6-.9 1.4-.9 2.3 0 .7.2 1.5.7 2.1.4.6.9 1.1 1.4 1.6.6.6 1.1 1.3 1.3 2.2v.1c.1.5.2 1 .2 1.5-.1 3.5-2.5 6.5-5.9 7.3z"
      fill="#d74214"
    />
    <path
      d="M11.5 8.9c-.2-.4-.4-.9-.4-1.4 0-.3 0-.5.1-.8-.7.5-1.2 1.4-1.2 2.4v.5c.1.9.4 1.6 1.1 2.6 0 0 .8 1.2 1 2v.3c0 .3-.1.7-.3.9-1 1.3-2.8 1.6-4.1.7-.5-.4-.9-.9-1.1-1.5-.3.6-.4 1.3-.4 2 0 1.6.7 3 2 4l.2.1c2.4 1.6 5.7 1.5 8-.3l.1-.1c1-.8 1.5-2 1.5-3.2 0-.3 0-.7-.1-1 .1.5 0 1.1-.4 1.5-.9.9-2 1.5-3.3 1.7-1.1.1-2.3-.1-3.3-.7.4.2.9.3 1.4.3 1.7 0 3.2-.9 4-2.3.5-1 .5-2.2-.2-3.2s-1.7-1.7-2.7-2.4c-1-.8-1.5-1.3-1.9-2.1"
      fill="#ffed58"
    />
    <path
      d="M11.2 6.8c-.3.5-.5 1.1-.5 1.8s.2 1.5.7 2.1c.4.6.9 1.1 1.4 1.6.6.6 1.1 1.3 1.3 2.2v.1c.1.5.2 1 .2 1.5 0 .9-.1 1.7-.4 2.5 1-.4 1.9-1.1 2.4-2.1s.5-2.2-.2-3.2-1.7-1.7-2.7-2.4c-.9-.6-1.3-1.1-1.8-1.9-.2-.4-.4-.9-.4-1.4-.1-.3 0-.6 0-.8zM16.3 20.4c1.1-.9 1.6-2 1.6-3.3 0-.3 0-.7-.1-1 .1.5 0 1.1-.4 1.5-.9.9-2 1.5-3.3 1.7h-.6c-.5 1-1.2 1.9-2.1 2.6h.7c1.5 0 3-.5 4.2-1.5z"
      fill="#fbd734"
    />
  </g>
)

export const ICON_FACEBOOK = (
  <path
    d="M2.7 0h18.7C22.8 0 24 1.2 24 2.7v18.7c0 1.5-1.2 2.7-2.7 2.7H2.7C1.2 24 0 22.8 0 21.3V2.7C0 1.2 1.2 0 2.7 0M20 2.7h-3.3c-2.6 0-4.7 2.1-4.7 4.7v3.3H9.3v4H12V24h4v-9.3h4v-4h-4V8c0-.7.6-1.3 1.3-1.3H20v-4z"
    fill="#4861a2"
  />
)

export const ICON_MESSENGER = (
  <path
    d="M12 0C5.4 0 0 5 0 11.1c0 3.5 1.7 6.5 4.4 8.6l.1 4.3 4.1-2.3c1.1.3 2.2.5 3.4.5 6.6 0 12-5 12-11.1S18.6 0 12 0m1.2 14.9l-3-3.2-6 3.2 6.5-6.8 3.1 3 5.8-3-6.4 6.8z"
    fill="#007eff"
  />
)

export const ICON_ALERT = (
  <g>
    <path
      d="M23.5 17.6l-2-3.7-2-3.7-2-3.7-2-3.7c-.2-.3-.4-.7-.7-.9s-.4-.7-.7-.9c-.3-.2-.7-.3-1-.4-.4-.1-.7-.2-1.1-.2-.4 0-.8.1-1.1.2-.4.1-.7.2-1 .4-.4.2-.6.4-.9.7s-.5.5-.7.9l-2 3.7-2 3.7-2 3.7-2 3.7c-.2.3-.3.7-.4 1 .1.5.1.9.1 1.2 0 .4.1.7.2 1 .1.3.2.7.4 1s.4.6.7.8c.3.2.5.5.8.6.3.2.6.3 1 .4.3.1.7.1 1.1.1h15.6c.4 0 .7 0 1.1-.1.3-.1.7-.2 1-.4.3-.2.6-.4.8-.6.3-.2.5-.5.7-.8s.3-.6.4-1c.1-.3.2-.7.2-1 0-.4 0-.7-.1-1-.1-.4-.2-.7-.4-1z"
      fill="#f74028"
    />
    <path
      d="M16.9 5l-1.3-2.4c-.2-.3-.4-.7-.7-.9s-.4-.5-.8-.7c-.3-.2-.7-.3-1-.4-.4-.1-.7-.2-1.1-.2-.4 0-.8.1-1.1.2s-.7.2-1 .4c-.3.2-.6.4-.9.7s-.5.5-.6.9l-2 3.7-2 3.7-2 3.7-2 3.7c-.2.3-.3.7-.4 1v1.2c0 .4.1.7.2 1 .1.3.2.7.4 1s.4.6.7.8c.3.2.5.5.8.6.3.2.6.3 1 .4.3.1.7.1 1.1.1h2.7L16.9 5z"
      fill="#f2582c"
    />
    <path
      d="M11 10.6l.3 2.4.2 2.5h1l.3-2.5.2-2.4.3-2.5.2-2.5h-3l.3 2.5zM13.1 17.3c-.1-.1-.3-.2-.5-.3-.2-.1-.4-.1-.6-.1-.2 0-.4 0-.6.1-.2.1-.3.2-.5.3-.1.1-.2.3-.3.5-.1.2-.1.4-.1.6 0 .2 0 .4.1.6.1.2.2.3.3.5.1.1.3.2.5.3.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.3-.2.5-.3.1-.1.2-.3.3-.5s.1-.4.1-.6c0-.2 0-.4-.1-.6-.1-.2-.2-.4-.3-.5z"
      fill="#FFFFFF"
    />
  </g>
)

export const ICON_CROWN = (
  <g>
    <path
      fill="#DD9615"
      d="M4.8 19.174l.46 1.347a16.268 16.268 0 0 1 6.733-1.449c2.412 0 4.701.524 6.762 1.463l.462-1.347a17.68 17.68 0 0 0-7.224-1.533c-2.561 0-4.995.543-7.193 1.519"
    />
    <path
      fill="#F8C34A"
      d="M4.8 19.174l.46 1.347a16.268 16.268 0 0 1 6.733-1.449v-1.417c-2.561 0-4.995.543-7.193 1.519"
    />
    <path
      fill="#D78415"
      d="M19.217 19.188a17.62 17.62 0 0 0-1.987-.747l-.748 1.257c.783.224 1.542.504 2.273.837l.462-1.347z"
    />
    <path
      fill="#F8C34A"
      d="M11.535 5.627l-4.343 9.077-5.084-5.45-.547.436 2.986 8.754a18.457 18.457 0 0 1 7.445-1.557l.027-11.201-.484-.059z"
    />
    <path fill="#D78415" d="M2.108 9.254l5.084 5.45.688-1.424z" />
    <path
      fill="#DD9615"
      d="M13.16 4.607a1.16 1.16 0 1 1-2.32 0 1.16 1.16 0 0 1 2.32 0M2.318 8.629a1.16 1.16 0 1 1-2.319 0 1.16 1.16 0 0 1 2.319 0"
    />
    <path fill="#D78415" d="M2.108 9.254l5.084 5.45.688-1.424z" />
    <path
      fill="#DD9615"
      d="M24 8.629a1.16 1.16 0 1 1-2.319 0 1.16 1.16 0 0 1 2.319 0"
    />
    <path
      fill="#D78415"
      d="M19.47 18.452l3.01-8.755-4.84 8.06c.625.2 1.236.432 1.83.695"
    />
    <path
      fill="#DD9615"
      d="M19.461 18.448l.01.004zM17.64 17.757l4.83-8.043-.561-.437-5.746 4.003-3.648-7.653-.496.059-.027 11.201c1.981 0 3.89.306 5.68.882l-.032-.012z"
    />
  </g>
)



// WEBPACK FOOTER //
// ./src/components/common/Icon.js